import { useState } from "react";
import { Button, Autocomplete, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ApiRequest } from "GlobalFunctions";
import debounce from "lodash/debounce";
import InvoiceClientDialog from "./InvoiceClientDialog";
import { ClientData } from "../helpers/invoiceUtils";

interface Props {
  selectedClient: ClientData | null;
  onClientSelect: (client: ClientData | null) => void;
}

export default function ClientSelector({ selectedClient, onClientSelect }: Props) {
  const [options, setOptions] = useState<any[]>([]);
  const [openDialog, setOpenDialog] = useState(false);

  const searchClients = debounce((inputValue: string) => {
    if (!inputValue) return;
    ApiRequest({
      url: "/clients/list",
      method: "get",
      headers: { ltkn: localStorage.getItem("ltkn") },
      query: { full_list: true, filters: { search: { value: inputValue } } },
      setResponse: (response: any) => {
        setOptions(response.list || []);
      },
    });
  }, 400);

  const handleSelect = (_: any, value: any) => {
    if (!value) { onClientSelect(null); return; }
    ApiRequest({
      url: "/clients/details",
      method: "get",
      headers: { ltkn: localStorage.getItem("ltkn") },
      query: { client_id: value.client_id },
      setResponse: (response: any) => {
        onClientSelect(response.data);
      },
    });
  };

  return (
    <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
      <Autocomplete
        fullWidth
        options={options}
        getOptionLabel={(opt: any) => `${opt.business_name || ''} - ${opt.client_name || ''} ${opt.client_last_name || ''} (${opt.document || ''})`}
        onInputChange={(_, val) => searchClients(val)}
        onChange={handleSelect}
        renderInput={(params) => <TextField {...params} label="Buscar cliente" placeholder="Nombre, NIT o código..." />}
        noOptionsText="Escriba para buscar..."
        isOptionEqualToValue={(opt: any, val: any) => opt.client_id === val.client_id}
      />
      <Button variant="outlined" startIcon={<AddIcon />} onClick={() => setOpenDialog(true)} sx={{ whiteSpace: "nowrap", minWidth: 160 }}>
        Nuevo Cliente
      </Button>

      <InvoiceClientDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onCreated={(client) => onClientSelect(client)}
      />
    </div>
  );
}
